module.exports = __webpack_public_path__ + "static/img/14.b241fe75.jpg";